module.exports = __webpack_public_path__ + "static/media/phone.7d021799.svg";